/*
 * Copyright (c) SEQTA Software 2018.
 *
 * Created by simon on 2018-05-02
 */


/**
 * With this permission, admin users are able to update syllabus sets and versions.
 */
export const admin_syllabus = 'admin_syllabus';

/**
 * With this permission, admin users are able to grant permissions to other users, as well as create and update their details.
 */
export const admin_user = 'admin_user';



// WEBPACK FOOTER //
// ./src/permissions.js